import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trending-down",
  "use": "trending-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"trending-down\">\n<path d=\"M23,19c-0.3,0-0.5-0.1-0.7-0.3l-8.8-8.8l-4.3,4.3c-0.4,0.4-1,0.4-1.4,0L0.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l6.8,6.8\n\tl4.3-4.3c0.4-0.4,1-0.4,1.4,0l9.5,9.5c0.4,0.4,0.4,1,0,1.4C23.5,18.9,23.3,19,23,19z\" />\n<path d=\"M23,19h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h5v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v6C24,18.6,23.6,19,23,19z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol